import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';

interface User {
  avatar_url?: string;
  is_ambassador?: boolean;
  is_employee?: boolean;
  user_type?: string;
  platform_roles?: {
    pm?: boolean;
    ttl?: boolean;
  };
}

interface Badge {
  cssClass: string;
  title: string;
}

@Component({
  selector: 'ut-avatar-badges',
  templateUrl: './avatar-badges.component.html',
  styleUrls: ['./avatar-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvatarBadgesComponent implements OnInit {
  @Input() user: User | 'me' = null;
  @Input() size: 'default' | 'large' | 'xlarge' | 'larger' | 'xxlarge' = 'default';

  badges: Badge[] = [];
  backgroundImageUrl: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    if (this.user === 'me') {
      this.UserService.me().then((res: any) => {
        if (res !== null) {
          this.setupBadges(res.data);
        } else {
          this.setupBadges({});
        }
      });
    } else if (this.user) {
      this.setupBadges(this.user as User);
    }
  }

  private setupBadges(user: User): void {
    this.badges = [];
    const titles: string[] = [];

    if (user.avatar_url) {
      this.backgroundImageUrl = `url(${user.avatar_url})`;
    }

    if (user.is_ambassador) {
      this.badges.push({
        cssClass: 'avatar-badge-a',
        title: 'uTest Ambassador',
      });
      titles.push('uTest Ambassador');
    }

    if (user.is_employee) {
      this.badges.push({
        cssClass: 'avatar-badge-u',
        title: 'uTest Employee',
      });
      titles.push('uTest Employee');
    }

    if (user.user_type === 'moderator' || user.user_type === 'admin') {
      this.badges.push({
        cssClass: 'avatar-badge-m',
        title: 'Moderator',
      });
      titles.push('Moderator');
    }

    if (user.platform_roles) {
      if (user.platform_roles.pm) {
        this.badges.push({
          cssClass: 'avatar-badge-pm',
          title: 'Project Manager',
        });
        titles.push('Project Manager');
      }

      if (user.platform_roles.ttl) {
        this.badges.push({
          cssClass: 'avatar-badge-ttl',
          title: 'Test Team Lead',
        });
        titles.push('Test Team Lead');
      }
    }

    this.cdr.markForCheck();
  }

  get badgeTitles(): string {
    return this.badges.map(badge => badge.title).join(', ');
  }
}
